import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    
    onMounted(() => {
        // 设置element-ui的皮肤颜色
        document.body.style.setProperty('--el-color-primary', '#2f3b6e'); // primary按钮颜色
        document.body.style.setProperty('--el-color-primary-light-3', '#27315a'); // primary按钮移上去的颜色
        document.body.style.setProperty('--el-color-primary-dark-2', '#2f3b6e'); // active状态
        document.body.style.setProperty('--el-color-primary-light-5', '#ced6e0'); // disabled状态的颜色
        document.body.style.setProperty('--el-color-primary-light-7', '#ced6e0'); // 透明移上去的边框颜色
        document.body.style.setProperty('--el-color-primary-light-9', '#f1f2f6'); // 透明移上去的颜色
        document.body.style.setProperty('--el-color-danger', '#f44336'); // danger按钮颜色
    });


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})